import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles'
import style, { headerClose, searchAndFilterButton } from './SearchAndFilter.scss'; // eslint-disable-line css-modules/no-unused-class

import { withRtl } from '../hoc';
import Checkbox from '../Checkbox';
import Accordion from '../Accordion';
import ButtonAction from '../ButtonAction';
import SearchField from '../SearchField';

import CaretDownIcon from '../icons/CaretDown';
import CaretUpIcon from '../icons/CaretUp';
import MapPinOutlineIcon from '../icons/MapPinOutline';
import ListIcon from '../icons/List';

import { windowVerticalHeight, detectActivationEvent } from '../../utils/helpers';
import messages from '../../locale/messages';
import GOATSearchContainer from '../../containers/GOATSearchContainer';
import CloseIcon from '../../components/icons/Close';
import {customisedIntlFormatMessage} from '../../utils/helpers';

export const VIEWS = {
  list: 'list',
  map: 'map',
};

class SearchAndFilter extends Component {
  static propTypes = {
    autocomplete: PropTypes.bool,
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        optionGroups: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            options: PropTypes.arrayOf(
              PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                selected: PropTypes.bool,
              }),
            ),
          }),
        ),
      }),
    ).isRequired,
    apply: PropTypes.func.isRequired,
    toggleMap: PropTypes.func.isRequired,
    searchfieldItems: PropTypes.arrayOf(PropTypes.string),
    searchfieldOnSearch: PropTypes.func,
    searchfieldOnClick: PropTypes.func,
    searchfieldOnChangeValue: PropTypes.func,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }).isRequired,
    mapIsOpen: PropTypes.bool,
    user: PropTypes.shape().isRequired,
    isLoggedIn: PropTypes.bool,
    handlePlaceChange: PropTypes.func,
    handleClearAddress: PropTypes.func,
    display: PropTypes.string,
    selectSavedProgramsFilter: PropTypes.bool,
  };

  static defaultProps = {
    autocomplete: true,
    searchfieldItems: [],
    searchfieldOnSearch: null,
    searchfieldOnClick: null,
    searchfieldOnChangeValue: null,
    mapIsOpen: false,
    isLoggedIn: false,
    handlePlaceChange: null,
    handleClearAddress: null,
    display: '',
    selectSavedProgramsFilter: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!_.isEqual(prevState.filters, nextProps.filters)) {
      return {
        ...prevState,
        filters: nextProps.filters,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      mapIsOpen: props.mapIsOpen,
      filters: props.filters,
      filtersUpdated: false,
      // 66px = bottom `reset` and `apply` bar height
      // 10px margin top
      // add 10px for space above bar
      filtersWrapperHeight: windowVerticalHeight() - (66 + 20),
    };

    const { apply, selectSavedProgramsFilter } = this.props;

    if (selectSavedProgramsFilter) {
      const { filters } = this.state;
      apply({ filters });
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    this.handleClose();
    window.removeEventListener('resize', this.updateDimensions);
  }

  onOptionChange = (filterIndex, groupIndex, optionValue, checked) => {
    const { filters } = this.state;
    const { optionGroups } = filters[filterIndex];
    const optionGroup = optionGroups[groupIndex];
    const option = optionGroup.options.find(opt => opt.value === optionValue);
    option.selected = checked;
    if (checked) {
      option.true = {
        id: option.value,
        label: option.label,
        section: option.id,
      };
    } else {
      delete option.true;
    }

    this.setState({
      ...this.state,
      filters,
      filtersUpdated: true,
    });
  };

  setAccordionLabel = ({ label, selected }) => {
    if (selected < 1) {
      return label;
    }
    return `${label} (${selected})`;
  };

  updateDimensions = () => {
    this.setState({
      ...this.state,
      filtersWrapperHeight: windowVerticalHeight() - (66 + 20),
    });
  };

  handleClose = (apply_filters=true) => {
    const { apply } = this.props;
    const { filtersUpdated, filters } = this.state;
    if (filtersUpdated && apply_filters) {
      apply({ filters });
    }

    this.setState({
      ...this.state,
      open: false,
      filtersUpdated: false,
    });

    document.body.style.overflow = 'initial';
    const topNav = document.querySelector('.top-nav');
    const mainNav = document.querySelector('.main-nav');
    const footer = document.querySelector('.footer');

    if (topNav) {
      topNav.style.display = 'flex';
    }

    if (mainNav) {
      mainNav.style.display = 'flex';
    }

    if (footer) {
      footer.style.display = 'block';
    }

    document.querySelector(`.${searchAndFilterButton}`).focus();
  };

  toggle = () => {
    const isOpen = !this.state.open;

    if (!isOpen) {
      this.handleClose();
    } else {
      this.setState(
        {
          ...this.state,
          open: !this.state.open,
        },
        () => {
          document.body.style.overflow = !this.state.open ? 'initial' : 'hidden';
          const topNav = document.querySelector('.top-nav');
          const mainNav = document.querySelector('.main-nav');
          const footer = document.querySelector('.footer');

          if (topNav) {
            topNav.style.display = !this.state.open ? 'flex' : 'none';
          }

          if (mainNav) {
            mainNav.style.display = !this.state.open ? 'flex' : 'none';
          }

          if (footer) {
            footer.style.display = !this.state.open ? 'block' : 'none';
          }

          document.querySelector(`.${headerClose}`).focus();
        },
      );
    }
  };

  toggleKeyDown = event => {
    if (detectActivationEvent(event)) {
      event.preventDefault();
      this.toggle();
    }
  };

  handleReset = () => {
    const { apply } = this.props;
    const { filters } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    let showSavedProgramsOnly = urlParams.get('saves');
    const resetFilters = filters.map(filter => {
      filter.optionGroups.forEach(optionGroup => {
        optionGroup.options.map(option => {
          const o = option;
          if ((o.true && o.id != 'saved_programs') || (o.id == 'saved_programs' && showSavedProgramsOnly != '1')) {
            o.selected = false;
            delete o.true;
          }
          return o;
        });
      });
      return filter;
    });

    this.setState({
      ...this.state,
      filters: resetFilters,
    });

    apply({
      filters: resetFilters,
    });
    // Toggling the open/close state so that overflow on body is set correctly
    this.toggle();
  };

  handlesSearchfieldOnClick = string => {
    const { searchfieldOnClick } = this.props;
    // avoiding filters when user click on the autocomplete results mys-779
    this.handleClose(false);
    searchfieldOnClick(string);
  };

  handleToggleMap = () => {
    const { toggleMap } = this.props;
    const { mapIsOpen } = this.state;

    this.setState({
      ...this.state,
      mapIsOpen: !mapIsOpen,
    });

    toggleMap({
      isOpen: !mapIsOpen,
    });
  };

  handleSearchQuery = ({ optionGroups }) => {
    const { searchfieldOnSearch } = this.props;
    searchfieldOnSearch({ optionGroups });
    this.toggle();
  };

  render() {
    const { autocomplete, searchfieldItems, searchfieldOnChangeValue, intl, user, isLoggedIn } = this.props;
    const { filters, open, mapIsOpen, filtersWrapperHeight } = this.state;
    const allOptionGroups = filters.map(({ optionGroups }) => optionGroups);
    const allOptionsForTotal = _.flattenDeep(allOptionGroups).map(({ options }) => options);
    const selectedForTotal = _.flattenDeep(allOptionsForTotal)
      .map(({ selected }) => selected)
      .filter(n => n);

    const totalSelectedLabel = selectedForTotal.length ? ` (${selectedForTotal.length})` : '';

    const searchAndFilterButtonsClasses = [style.searchAndFilterButton];
    if (selectedForTotal.length) {
      searchAndFilterButtonsClasses.push(style.searchAndFilterButtonHasSelected);
    }

    const mainButtonsClasses = [style.mainButtons];
    if (mapIsOpen) {
      mainButtonsClasses.push(style.mainButtonsMapIsClicked);
    }
    const icon = mapIsOpen ? <ListIcon size={25} fill="#4ee4b3" /> : <MapPinOutlineIcon size={25} fill="#4ee4b3" />;

    let searchBarPlaceholder;
    if (user.isPK || user.is2K || user.is3K) {
      searchBarPlaceholder = messages.searchfieldPlaceholderSchoolsForPKAnd3K;
    } else {
      searchBarPlaceholder = messages.searchfieldPlaceholderSchools;
    }

    return (
      <div className={style.root + ' exclude-print'}>
        <div className={classNames(...mainButtonsClasses)}>
          <button
            className={classNames(...searchAndFilterButtonsClasses)}
            onClick={this.toggle}
            aria-label={customisedIntlFormatMessage(intl, messages.searchAndFilterToggleAriaLabel)}
          >
            <h1>
              <FormattedMessage {...messages.searchAndFilterSearchAndFilter} />
            </h1>
            {totalSelectedLabel}
            <CaretDownIcon size={10} fill="#0345a7" />
          </button>
          <button
            className={style.toggleMapButton}
            onClick={this.handleToggleMap}
            aria-label={customisedIntlFormatMessage(intl, messages.searchAndFilterToggleMapAriaLabel)}
          >
            {icon}
          </button>
        </div>
        {open && (
          <div>
            <div className={style.filtersBackground} />
            <div
              role="presentation"
              className={style.filtersWrapper}
              style={{
                height: `${filtersWrapperHeight}px`,
              }}
            >
              <div
                role="button"
                onClick={this.toggle}
                onKeyDown={this.toggleKeyDown}
                tabIndex="0"
                aria-label={customisedIntlFormatMessage(intl, messages.searchAndFilterToggleAriaLabel)}
                className={style.headerClose}
              >
                <FormattedMessage {...messages.searchAndFilterSearchAndFilter} />
                <CaretUpIcon size={16} fill="#024cbc" />
              </div>
              {!isLoggedIn && (
                <div className={style.userAddressContainer}>
                  <GOATSearchContainer
                    placeholder={customisedIntlFormatMessage(intl, messages.generalStringYourChildsAddress)}
                    ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringYourChildsAddress)}
                    onPlaceChange={this.props.handlePlaceChange}
                    // handlePlaceChangeGooglePlaces={this.handlePlaceChangeGooglePlaces}
                    hidden={user.set}
                  />
                  {user.set && (
                    <div className={style.userAddress}>
                      <span>{user.formattedAddress}</span>
                      <div className={style.clearAddressWrapper}>
                        <CloseIcon
                          size={12}
                          fill="#024cbc"
                          onClick={this.props.handleClearAddress}
                          aria-label={customisedIntlFormatMessage(intl, messages.generalStringClearAddress)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <SearchField
                items={searchfieldItems}
                onClick={this.handlesSearchfieldOnClick}
                onSearch={this.handleSearchQuery}
                onChangeValue={searchfieldOnChangeValue}
                placeholder={searchBarPlaceholder}
                autocomplete={autocomplete}
                isMobile
                user={user}
                display={this.props.display}
              />
              <div className={style.groupsWrapper}>
                {filters.map((filter, filterIndex) => {
                  const allOptions = filter.optionGroups.map(({ options }) => options);
                  const selected = _.flattenDeep(allOptions)
                    // eslint-disable-next-line no-shadow
                    .map(({ selected }) => selected)
                    .filter(n => n);

                  return (
                    <Accordion
                      key={filter.label}
                      label={this.setAccordionLabel({
                        label: filter.label,
                        selected: selected.length,
                      })}
                      flipped
                    >
                      <div>
                        {filter.optionGroups.map((optionGroup, groupIndex) => (
                          <div className={style.group} key={`${optionGroup.id}${optionGroup.label}`}>
                            <div className={style.label}>{optionGroup.label}</div>
                            {optionGroup.desc && <div className={style.desc}>{optionGroup.desc}</div>}
                            {optionGroup.options.map(option => {
                              const key = `${optionGroup.id}-${option.value}-${option.label}`;

                              const onChange = event => {
                                this.onOptionChange(
                                  filterIndex,
                                  groupIndex,
                                  option.value,
                                  event.currentTarget.checked,
                                  // option.label, // sk: not used?
                                );
                              };

                              let disableFilter = false;
                              if (option.id === 'saved_programs'){
                                const urlParams = new URLSearchParams(window.location.search);
                                let showSavedProgramsOnly = urlParams.get('saves');
                                if (showSavedProgramsOnly == '1')
                                  disableFilter = true;
                              }
                              return (
                                <Checkbox
                                  key={key}
                                  id={key}
                                  value={option.value}
                                  checked={option.selected}
                                  label={option.label}
                                  onChange={onChange}
                                  disabled={disableFilter}
                                  disabledForSavedPrograms={disableFilter}
                                />
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    </Accordion>
                  );
                })}
              </div>
            </div>
            <div className={style.stickyApply}>
              <button
                className={style.reset}
                onClick={this.handleReset}
                aria-label={customisedIntlFormatMessage(intl, messages.searchAndFilterReset)}
              >
                <FormattedMessage {...messages.searchAndFilterReset} />
              </button>
              <ButtonAction
                onClick={this.handleClose}
                icon="Check"
                ariaLabel={customisedIntlFormatMessage(intl, messages.searchAndFilterApply)}
                label={<FormattedMessage {...messages.searchAndFilterApply} />}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(style)(withRtl(style)(injectIntl(SearchAndFilter)));
